import React from "react";
import { connect } from "react-redux";
import { Formik, FormikProps, Form, Field } from "formik";
import * as yup from "yup";

import Modal from "../../modal";
import PopConfirm from "../../modal/PopConfirm";
import {
  create,
  update,
  destroy,
} from "../redux/actions/requirementFieldAction";
import Input from "../../DataEntry/Input";
import Select from "../../DataEntry/Select";

class ManageRequirement extends React.Component<any, any> {
  initialValues = { title: "", data_type: "text" };

  constructor(props: any) {
    super(props);
    this.state = { initialValues: this.initialValues };
  }

  handleDestroy = (id: number) => {
    const { destroy, onDestroy } = this.props;
    destroy(id).then(() => {
      onDestroy(id);
    });
  };

  handleSelect = (contact: any) => {
    this.setState({ initialValues: { ...contact } });
  };

  handleSubmit = (data: any, formik: any) => {
    const { create, update } = this.props;
    (data.id ? update : create)(data)
      .then(() => {
        this.setState({ initialValues: this.initialValues });
      })
      .catch(() => {})
      .finally(formik.resetForm);
  };

  validationSchema = () =>
    yup.object().shape({
      title: yup.string().required(" ").nullable(),
      data_type: yup.string().required(" ").nullable(),
    });

  render() {
    const { fields, permissions } = this.props;
    const { initialValues } = this.state;

    return (
      <>
        <a onClick={() => $("#requirement-modal").modal("show")}>Manange</a>
        <Modal id="requirement-modal" title="Manage Requirements">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={this.validationSchema()}
            onSubmit={this.handleSubmit}
          >
            {(props: FormikProps<any>) => (
              <Form id="requirement-form" className="sn-form">
                <div className="row">
                  <div className="col-xs-1">
                    <label
                      htmlFor="title"
                      className="required"
                      style={{ paddingTop: "6px" }}
                    >
                      Title
                    </label>
                  </div>
                  <div className="col-xs-5" style={{ paddingLeft: "4px" }}>
                    <Field
                      name="title"
                      className="form-control"
                      style={{ width: "100%", height: "unset" }}
                      component={Input}
                    />
                  </div>
                  <div className="col-xs-1" />
                  <div className="col-xs-1">
                    <label
                      htmlFor="data_type"
                      className="required"
                      style={{ paddingTop: "6px" }}
                    >
                      Type
                    </label>
                  </div>
                  <div className="col-xs-2" style={{ paddingLeft: "4px" }}>
                    <Field
                      name="data_type"
                      className="form-control"
                      style={{ width: "100%", height: "unset" }}
                      component={Select}
                      list={[
                        "Text",
                        "Number",
                        "Date",
                        "DateTime",
                        "Boolean",
                        "Currency",
                      ]}
                    />
                  </div>
                  <div
                    className="col-xs-1 inline-btn"
                    style={{ paddingTop: "3px" }}
                  >
                    <button
                      form="requirement-form"
                      type="submit"
                      className="sn-transparent-btn"
                    >
                      <i
                        className={`fa fa-${props.values.id ? "floppy-o" : "plus"} text-success fa-2x`}
                        title="Save"
                        data-toggle="tooltip"
                      />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <div className="row" style={{ margin: "unset" }}>
            <div className="col-xs-12">
              <table className="sn-table table table-hover table-striped table-responsive">
                <thead className="gray-header">
                  <tr>
                    <th className="text-left" style={{ width: "60%" }}>
                      Title
                    </th>
                    <th className="text-center">Type</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {fields.map((field: any) => (
                    <tr key={field.id}>
                      <td className="text-left">{field.title}</td>
                      <td
                        className="text-center"
                        style={{ textTransform: "capitalize" }}
                      >
                        {field.data_type}
                      </td>
                      <td className="text-center sn-icons">
                        <a
                          className="fa fa-edit fa-2x edit-icon"
                          onClick={() => this.handleSelect(field)}
                        />
                        {permissions.location_delete_requirements ? (
                          <PopConfirm
                            text="Deleting an item from this section will remove it for all locations."
                            onConfirm={() => this.handleDestroy(field.id)}
                          >
                            <a className="fa fa-2x fa-minus-circle delete-icon" />
                          </PopConfirm>
                        ) : (
                          <a className="fa fa-2x fa-minus-circle disabled" />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  fields: state.fields.data,
  permissions: state.permissions.data,
});

const mapDispatchToProps = { create, update, destroy };

export default connect(mapStateToProps, mapDispatchToProps)(ManageRequirement);
